export const dispositionOptions: string[] = [
  'Contact Made - IP/CP',
  'Contact Made - WN-NIS - TLO Required for CP',
  'No Contact Made - LVM',
  'Contact Made - Relative/TP',
  'Training',
  'TLO Research',
  'LCP Research',
  'Contact Made - Call Disconnected',
  'IP/CP Contact Made Call Back Scheduled',
  'Contact Made - Form Submitted',
  'No Contact Made - VM - TLO Required CP',
  'Inbound Calls',
  'No Contact - VM',
  'Contact Made - Escalated Onshore',
  'CLJA Partial Form Updated',
  'No Contact Made - LVM',
  'Texting & Emailing',
  'No Contact Made - No Answer',
  'No Contact Made - NIS',
  'IP/CP/RT Contact Made - Call Back Scheduled',
  'FTL Data Entry',
  'Short Break',
  'Long Break',
  'Restroom',
  'Outbound Calls',
  'All Attempts Exhausted',
  'Downtime',
  'Paralegal Task',
  'Amendment/Correction',
  'No Contact Made - Callback request taken',
  'No Contact Made - Email to be sent or required by Attorney',
  'Contact Made - Meeting Scheduled / Need more info on services',
  'Contact Made - Attorney will follow up',
  'Contact made - Attorney Not interested',
  'Active Opportunities on CRM',
];
